module.exports = {
  PROD_URL: process.env.REACT_APP_NODE_API_URL,
  // ATTENDANCE_TOKEN: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJTbWFydFdvcmsiLCJpYXQiOjE2NjI0NTc0MDMsImV4cCI6MTY5OTI2MzgwMywiYXVkIjoid3d3LnNtYXJ0d29ya3NvZmZpY2UuY29tIiwic3ViIjoiQXR0ZW5kYW5jZSBNYW5hZ2VtZW50IiwiX2lkIjoiNjMxNmY3MTU1MjVhZjcwNGZiMDlkYWZkIiwiY2xpZW50TmFtZSI6IlNtYXJ0V29ya3MiLCJjbGllbnRJZCI6IjIwMiIsImNsaWVudExhdCI6IjI4LjU3NTIyMCIsImNsaWVudExvbmciOiI3Ny4zMTUyOTAiLCJjbGllbnREYk5hbWUiOiJzbWFydHdvcmtzX3N1aHYifQ.zdavRzpNggcsK1jVXKrwbz0Z0Has9dX4YyAfBVqdR0A'
  AMS_URL: process.env.REACT_APP_AMS_URL,
  MEAL_PLANS_TOKEN: 'wt41PdXA0L4S_6fwssB2SQ8inajVzV6z8lZe-eCzNxcQdmsvQjEKn5U2QDIAKT2amkkxQ',
  EMPLOYEE_COUNT_TARGET: 10,
  WALLET_POINT_AUTHORIZATION: 'pGAw6KskEgC16ZdDfcAQLecFG2vLQa6OcB7PQGWB0CggEBA'
};

